import { render, staticRenderFns } from "./AccSettings.vue?vue&type=template&id=342cd00b"
import script from "./AccSettings.vue?vue&type=script&lang=js"
export * from "./AccSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports